import q from "./extends3.mjs";
import xe from "./objectWithoutPropertiesLoose3.mjs";
import * as u from "react";
import { useValidation as Ve } from "./useValidation.mjs";
import { useUtils as De } from "./useUtils.mjs";
import { getSectionOrder as ye, cleanString as y, isAndroid as Ee, adjustSectionValue as ve } from "./useField.utils.mjs";
import { useFieldState as we } from "./useFieldState.mjs";
import { useFieldCharacterEditing as be } from "./useFieldCharacterEditing.mjs";
import { getActiveElement as Q } from "./utils7.mjs";
import Ae from "./useForkRef.mjs";
import ke from "./useTheme.mjs";
import p from "./useEventCallback.mjs";
import Pe from "./useEnhancedEffect.mjs";
const Te = ["onClick", "onKeyDown", "onFocus", "onBlur", "onMouseUp", "onPaste", "error", "clearable", "onClear", "disabled"], Ze = (E) => {
  const v = De(), {
    state: r,
    selectedSectionIndexes: n,
    setSelectedSections: a,
    clearValue: w,
    clearActiveSection: b,
    updateSectionValue: A,
    updateValueFromValueStr: M,
    setTempAndroidValueStr: O,
    sectionsValueBoundaries: B,
    placeholder: W,
    timezone: k
  } = we(E), {
    inputRef: J,
    internalProps: X,
    internalProps: {
      readOnly: d = !1,
      unstableFieldRef: Y,
      minutesStep: ee
    },
    forwardedProps: {
      onClick: U,
      onKeyDown: _,
      onFocus: K,
      onBlur: L,
      onMouseUp: N,
      onPaste: $,
      error: P,
      clearable: te,
      onClear: z,
      disabled: H
    },
    fieldValueManager: V,
    valueManager: m,
    validator: ne
  } = E, re = xe(E.forwardedProps, Te), {
    applyCharacterEditing: oe,
    resetCharacterQuery: S
  } = be({
    sections: r.sections,
    updateSectionValue: A,
    sectionsValueBoundaries: B,
    setTempAndroidValueStr: O,
    timezone: k
  }), s = u.useRef(null), se = Ae(J, s), T = u.useRef(void 0), g = ke().direction === "rtl", D = u.useMemo(() => ye(r.sections, g), [r.sections, g]), Z = () => {
    var e;
    if (d) {
      a(null);
      return;
    }
    const t = (e = s.current.selectionStart) != null ? e : 0;
    let o;
    t <= r.sections[0].startInInput || t >= r.sections[r.sections.length - 1].endInInput ? o = 1 : o = r.sections.findIndex((i) => i.startInInput - i.startSeparator.length > t);
    const l = o === -1 ? r.sections.length - 1 : o - 1;
    a(l);
  }, le = p((e, ...t) => {
    e.isDefaultPrevented() || (U?.(e, ...t), Z());
  }), ae = p((e) => {
    N?.(e), e.preventDefault();
  }), ie = p((...e) => {
    K?.(...e);
    const t = s.current;
    window.clearTimeout(T.current), T.current = setTimeout(() => {
      !t || t !== s.current || n != null || d || (// avoid selecting all sections when focusing empty field without value
      t.value.length && Number(t.selectionEnd) - Number(t.selectionStart) === t.value.length ? a("all") : Z());
    });
  }), ce = p((...e) => {
    L?.(...e), a(null);
  }), ue = p((e) => {
    if ($?.(e), d) {
      e.preventDefault();
      return;
    }
    const t = e.clipboardData.getData("text");
    if (n && n.startIndex === n.endIndex) {
      const o = r.sections[n.startIndex], l = /^[a-zA-Z]+$/.test(t), i = /^[0-9]+$/.test(t), c = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(t);
      if (o.contentType === "letter" && l || o.contentType === "digit" && i || o.contentType === "digit-with-letter" && c) {
        S(), A({
          activeSection: o,
          newSectionValue: t,
          shouldGoToNextSection: !0
        }), e.preventDefault();
        return;
      }
      if (l || i) {
        e.preventDefault();
        return;
      }
    }
    e.preventDefault(), S(), M(t);
  }), de = p((e) => {
    if (d)
      return;
    const t = e.target.value;
    if (t === "") {
      S(), w();
      return;
    }
    const o = e.nativeEvent.data, l = o && o.length > 1, i = l ? o : t, c = y(i);
    if (n == null || l) {
      M(l ? o : c);
      return;
    }
    let x;
    if (n.startIndex === 0 && n.endIndex === r.sections.length - 1 && c.length === 1)
      x = c;
    else {
      const I = y(V.getValueStrFromSections(r.sections, g));
      let F = -1, R = -1;
      for (let f = 0; f < I.length; f += 1)
        F === -1 && I[f] !== c[f] && (F = f), R === -1 && I[I.length - f - 1] !== c[c.length - f - 1] && (R = f);
      const h = r.sections[n.startIndex];
      if (F < h.start || I.length - R - 1 > h.end)
        return;
      const ge = c.length - I.length + h.end - y(h.endSeparator || "").length;
      x = c.slice(h.start + y(h.startSeparator || "").length, ge);
    }
    if (x.length === 0) {
      Ee() ? O(i) : (S(), b());
      return;
    }
    oe({
      keyPressed: x,
      sectionIndex: n.startIndex
    });
  }), fe = p((e) => {
    switch (_?.(e), !0) {
      case (e.key === "a" && (e.ctrlKey || e.metaKey)): {
        e.preventDefault(), a("all");
        break;
      }
      case e.key === "ArrowRight": {
        if (e.preventDefault(), n == null)
          a(D.startIndex);
        else if (n.startIndex !== n.endIndex)
          a(n.endIndex);
        else {
          const t = D.neighbors[n.startIndex].rightIndex;
          t !== null && a(t);
        }
        break;
      }
      case e.key === "ArrowLeft": {
        if (e.preventDefault(), n == null)
          a(D.endIndex);
        else if (n.startIndex !== n.endIndex)
          a(n.startIndex);
        else {
          const t = D.neighbors[n.startIndex].leftIndex;
          t !== null && a(t);
        }
        break;
      }
      case e.key === "Delete": {
        if (e.preventDefault(), d)
          break;
        n == null || n.startIndex === 0 && n.endIndex === r.sections.length - 1 ? w() : b(), S();
        break;
      }
      case ["ArrowUp", "ArrowDown", "Home", "End", "PageUp", "PageDown"].includes(e.key): {
        if (e.preventDefault(), d || n == null)
          break;
        const t = r.sections[n.startIndex], o = V.getActiveDateManager(v, r, t), l = ve(v, k, t, e.key, B, o.date, {
          minutesStep: ee
        });
        A({
          activeSection: t,
          newSectionValue: l,
          shouldGoToNextSection: !1
        });
        break;
      }
    }
  });
  Pe(() => {
    if (!s.current)
      return;
    if (n == null) {
      s.current.scrollLeft && (s.current.scrollLeft = 0);
      return;
    }
    const e = r.sections[n.startIndex], t = r.sections[n.endIndex];
    let o = e.startInInput, l = t.endInInput;
    if (n.shouldSelectBoundarySelectors && (o -= e.startSeparator.length, l += t.endSeparator.length), o !== s.current.selectionStart || l !== s.current.selectionEnd) {
      const i = s.current.scrollTop;
      s.current === Q(document) && s.current.setSelectionRange(o, l), s.current.scrollTop = i;
    }
  });
  const j = Ve(q({}, X, {
    value: r.value,
    timezone: k
  }), ne, m.isSameError, m.defaultErrorState), C = u.useMemo(() => P !== void 0 ? P : m.hasError(j), [m, j, P]);
  u.useEffect(() => {
    !C && !n && S();
  }, [r.referenceValue, n, C]), u.useEffect(() => (s.current && s.current === document.activeElement && a("all"), () => window.clearTimeout(T.current)), []), u.useEffect(() => {
    r.tempValueStrAndroid != null && n != null && (S(), b());
  }, [r.tempValueStrAndroid]);
  const pe = u.useMemo(() => {
    var e;
    return (e = r.tempValueStrAndroid) != null ? e : V.getValueStrFromSections(r.sections, g);
  }, [r.sections, V, r.tempValueStrAndroid, g]), Se = u.useMemo(() => n == null || r.sections[n.startIndex].contentType === "letter" ? "text" : "numeric", [n, r.sections]), me = s.current && s.current === Q(document), G = m.areValuesEqual(v, r.value, m.emptyValue), Ie = !me && G;
  u.useImperativeHandle(Y, () => ({
    getSections: () => r.sections,
    getActiveSectionIndex: () => {
      var e, t;
      const o = (e = s.current.selectionStart) != null ? e : 0, l = (t = s.current.selectionEnd) != null ? t : 0;
      if (o === 0 && l === 0)
        return null;
      const i = o <= r.sections[0].startInInput ? 1 : r.sections.findIndex((c) => c.startInInput - c.startSeparator.length > o);
      return i === -1 ? r.sections.length - 1 : i - 1;
    },
    setSelectedSections: (e) => a(e)
  }));
  const he = p((e, ...t) => {
    var o;
    e.preventDefault(), z?.(e, ...t), w(), s == null || (o = s.current) == null || o.focus(), a(0);
  });
  return q({
    placeholder: W,
    autoComplete: "off",
    disabled: !!H
  }, re, {
    value: Ie ? "" : pe,
    inputMode: Se,
    readOnly: d,
    onClick: le,
    onFocus: ie,
    onBlur: ce,
    onPaste: ue,
    onChange: de,
    onKeyDown: fe,
    onMouseUp: ae,
    onClear: he,
    error: C,
    ref: se,
    clearable: !!(te && !G && !d && !H)
  });
};
export {
  Ze as useField
};
//# sourceMappingURL=useField.mjs.map
